import { render, staticRenderFns } from "./StarArticleItem.vue?vue&type=template&id=4e58b740"
import script from "./StarArticleItem.vue?vue&type=script&lang=js"
export * from "./StarArticleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports